import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { ROUTES, ROLES } from '@/constants';
import { useAuth } from '@/context';
import { Button } from '@/components/ui';

function PermissionDeniedPage() {
  const { user } = useAuth();
  const isScorer = user?.role === ROLES.SCORER;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <ShieldX className="h-8 w-8" aria-hidden="true" />
      </div>
      <h1 className="font-display text-2xl font-bold">Permission Denied</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        You do not have permission to access this page. Contact an administrator if you believe this
        is an error.
      </p>
      <Button asChild variant="primary" className="mt-6">
        <Link to={isScorer ? ROUTES.MATCHES : ROUTES.DASHBOARD}>
          {isScorer ? 'Back to My Matches' : 'Back to Dashboard'}
        </Link>
      </Button>
    </div>
  );
}

export default PermissionDeniedPage;
